import type { Vehicle } from '@/types';
import type { SiteAppearance } from '@/lib/storefront/appearance';
import type { StorefrontDocument } from '@/lib/storefront/document';

export interface SearchCriteria {
  location: string;
  pickupDate: string;
  pickupTime: string;
  dropoffDate: string;
  dropoffTime: string;
  rentalType: string;
}

/** Everything a design's home composition needs from the public site shell. */
export interface HomeDesignProps {
  vehicles: Vehicle[];
  favorites: string[];
  storefront: StorefrontDocument | null;
  /** Which sections the agency switched on for this design. */
  appearance: SiteAppearance;
  onToggleFavorite: (id: string) => void;
  onBookVehicle: (vehicle: Vehicle) => void;
  /** Opens the booking modal without a preselected car. */
  onBookAny: () => void;
  onViewAll: () => void;
  onViewDetails: (vehicle: Vehicle) => void;
  onSearch: (criteria: SearchCriteria) => void;
}

/** Vehicles the agency featured, or the whole fleet when none is pinned. */
export function featuredVehicles(vehicles: Vehicle[], storefront: StorefrontDocument | null): Vehicle[] {
  if (storefront && storefront.featuredVehicleIds.length > 0) {
    return vehicles.filter((vehicle) => storefront.featuredVehicleIds.includes(vehicle.id));
  }
  return vehicles;
}
